var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifyingGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 48,
    viewBox: "0 0 41 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.39734C4 5.07332 5.09682 4 6.4498 4C15.4833 4 24.5167 4.00007 33.5502 4.00001C34.9032 4 36 5.07333 36 6.39736V43.6027C36 44.9267 34.9032 46 33.5502 46C24.5167 46 15.4833 46 6.44981 46C5.09682 46 4 44.9267 4 43.6027V6.39734Z",
    fill: "#B1B0F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.39734C0 1.07332 1.09682 -3.53007e-07 2.4498 0C11.4833 2.35691e-06 20.5167 6.87111e-05 29.5502 1.12517e-05C30.9032 2.64562e-06 32 1.07333 32 2.39736V39.6027C32 40.9267 30.9032 42 29.5502 42C20.5167 42 11.4833 42 2.44981 42C1.09682 42 0 40.9267 0 39.6027V2.39734Z",
    fill: "#E6E5FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.9512,
    y: 30.123,
    width: 8,
    height: 4,
    transform: "rotate(45 24.9512 30.123)",
    fill: "#B1B0F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.6562,
    y: 33.4141,
    width: 16.0162,
    height: 6,
    rx: 2,
    transform: "rotate(45 29.6562 33.4141)",
    fill: "#8E8CEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 16,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 10,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 14,
    height: 2,
    rx: 1,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 24,
    r: 11.25,
    stroke: "#8E8CEE",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.f5f4664d697dd81c8c60f600e86646af.svg";
export { ForwardRef as ReactComponent };